const readMore = {
    wrap: document.querySelectorAll('.jsTextWrap'),
    btn: document.querySelectorAll('.jsReadMore'),
   
    init() {
      this.setBtn();
    },

    setBtn() {
        this.wrap.forEach((item, index)=>{
            let height = item.firstElementChild.offsetHeight;
            let itemHeight = item.offsetHeight;
            let btn =  this.btn[index];
        
           if(height <= itemHeight) {
                btn.classList.add('d-none');
           }
           btn.addEventListener('click', ()=>{
                if( btn.dataset.open === 'false') {
                    btn.dataset.open = 'true';
                    item.style.maxHeight = height + 30 + 'px';
                    btn.innerHTML = 'read less <i class="fal fa-chevron-double-right"></i>';
                }else{
                    btn.dataset.open = 'false';
                    item.style.maxHeight = itemHeight + 'px';
                    btn.innerHTML = 'read more <i class="fal fa-chevron-double-right"></i>';
                }
           });
        });
    },
    

}

export default readMore;